/** @description always include jQuery in this manner in every file where jQuery is used */
const $ = jQuery.noConflict();

'use strict';

const CompanyReview = {

	$domAddReviewBtn: '.js-add-review',
	classReview: '',
	isFetching: false,

	/**
	 * @description Initialize
	 */
	init: function() {
		this.bindEvents();
	},

	bindEvents: function() {
		$(document).on('click', this.$domAddReviewBtn, this.companyReview);
	},

	/**
	 * @description Handles add/edit company review
	 */
	companyReview: async function(event) {

		event.preventDefault();
		// close sugg popup after publishing review
		$('.js-sugg-popup-close').trigger('click');

		if (this.isFetching) {
			return;
		}

		this.isFetching = true;

		const $button = $(this);
		const review = document.querySelector('#sugg-text').value;
		const userId = $button.data('user-id');
		const companyId = $button.data('company-id');

		// if (!userId || review === '') {
		// 	console.error('User ID or review text missing');
		// 	this.isFetching = false;
		// 	return;
		// }
		console.log(window.apiSettings.token);
		try {
			const response = await fetch(`${window.origin}/wp-json/office-pulse-api/v1/review/create`, {
				method: 'POST',
				headers: {
					'Content-Type': 'application/json',
					'Authorization': `Bearer ${window.apiSettings.token}`
				},
				body: JSON.stringify({
					user_id: userId,
					review_text: review,
					company_id: companyId
				})
			});

			const result = await response.json();

			if (!response.ok) {
				console.error(result.error || 'Something went wrong');
				this.isFetching = false;
				return;
			}

			$('#js-company-suggestions__list').prepend(result.reviewHTML);

			console.log(result.message);

		} catch (error) {
			console.error('Error:', error);
		} finally {
			this.isFetching = false;
		}
	}
};

export default CompanyReview;
